const appGlobalScript = appGlobalScriptNs.default || (() => {});
import * as appGlobalScriptNs from '/home/runner/_work/core/core/packages/core/src/global/workbench-global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
